module.exports = __webpack_public_path__ + "static/media/05.4b4b07d1.png";